export enum AnnualRatingsPerformanceChartBlock {
  Root = 'AnnualRatingsPerformanceChart',
}
